import { UIText3, Image } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';
import { TAction } from '../../../types/customActions';

type TUserCardMobileCustomActionButton = {
  action: TAction;
  longText: string;
  iconUrl: string;
  onClick(action: TAction): void;
};

export const UserCardMobileCustomActionButton: React.FC<TUserCardMobileCustomActionButton> = ({
  action,
  longText,
  onClick,
  iconUrl,
}) => {
  return (
    <button
      type="button"
      onClick={() => onClick(action)}
      className={styles['button']}
      data-testid="UserCardMobileCustomActionButton"
    >
      <Image height={24} borderRadius="0" objectFit="contain" src={iconUrl} data-testid="image" />
      <UIText3 color="text-main-default">{longText}</UIText3>
    </button>
  );
};
